module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (192).ca6581c1.jpg";